import React from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, ZapIcon } from 'lucide-react';
export function ResultsSection() {
  const stats = [{
    icon: DollarSignIcon,
    value: '$500M+',
    label: 'Generados por estudiantes'
  }, {
    icon: UsersIcon,
    value: '5,000+',
    label: 'Estudiantes activos'
  }, {
    icon: TrendingUpIcon,
    value: '$8.5K',
    label: 'Promedio primer mes'
  }];
  return <section data-id="element-214">
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-215">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 text-center leading-tight" data-id="element-216">
          Resultados Reales de Mis Estudiantes
        </h2>
        <p className="text-lg md:text-xl text-gray-300 text-center mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-217">
          Esto es lo que puedes lograr cuando implementas correctamente el
          sistema que te enseñaré:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-218">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-gradient-to-br from-red-900/30 to-gray-900/50 rounded-xl p-6 md:p-8 text-center border border-red-800/30" data-id="element-219">
                <Icon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mx-auto mb-4" data-id="element-220" />
                <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2" data-id="element-221">
                  {stat.value}
                </div>
                <div className="text-base md:text-lg text-gray-300" data-id="element-222">
                  {stat.label}
                </div>
              </div>;
        })}
        </div>

        <div className="bg-gradient-to-r from-red-900/20 to-transparent border-l-4 border-red-500 p-6 md:p-8 rounded-lg" data-id="element-223">
          <div className="flex items-start gap-4" data-id="element-224">
            <ZapIcon className="h-8 w-8 text-red-400 flex-shrink-0 mt-1" data-id="element-225" />
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-226">
              Ventas automáticas de productos digitales generando ingresos
              mientras duermes
            </p>
          </div>
        </div>
      </div>
    </section>;
}